'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryCodes = exports.getCountries = undefined;

var _config = require('./config');

var _countries = require('../../static/countries.json');

var _countries2 = _interopRequireDefault(_countries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (process.env.NODE_ENV !== 'production') {
  if (!_countries2.default || Object.keys(_countries2.default).length === 0) {
    (0, _config.ThrowNoJsonLoaderError)();
  }
}

var getCountries = exports.getCountries = function getCountries() {
  return _countries2.default;
};
var getCountryCodes = exports.getCountryCodes = function getCountryCodes() {
  return getCountries().map(function (o) {
    return o.code;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/countries.js
// module id = 227
// module chunks = 0